<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
      :loading="false"
      :hasDownload="true"
  >
    <template #subHeaderActions>   
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <DateRangePicker id="stat-daterangepicker" @update:date="handleRangeDate" />
      </div>
    </template>
    
    <template #layoutContent>
      <CrmInvoiceStatByStatus :load-stats="loadWidgetStatData" :title="$t('invoices.invoice') " id="invoice" />

     

      <div class="card shadow-sm mb-5 card-flush overflow-hidden">
        <div class="card-header">
          <div class="card-title">
            <h5 style="text-align: start">{{ $t('invoices.top_clients') }}</h5>
          </div>
        </div>
        <div class="card-body d-flex text-center justify-content-center flex-column px-0">
          <div v-show="!topClients?.length" class="text-center">
            <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
            <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            <div class="text-gray-700 fs-4 fw-bold">{{ $t('crm.statistics.sale_estimate_validate') }}</div>
          </div>
          <div v-show="topClients?.length" class="p-5">
            <div class="row">
              <canvas id="kt_chartjs_top_clients" class="mh-400px"></canvas>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm mb-5 card-flush overflow-hidden">
        <div class="card-header">
          <div class="card-title">
            <h5 style="text-align: start">{{ $t('invoices.invoice_moyen') }}</h5>
          </div>
          <div class="card-toolbar">
            <ButtonDropdownFilter
                :btn-title="$t('pipelines.label.prospect')"
                :options="contacts"
                value-field="id"
                name-field="fullname"
                v-model="query.contact_id"
                :border="true"
            />
          </div>
        </div>
        <div class="card-body d-flex text-center justify-content-center flex-column px-0">
          <div v-show="getInvoiceAndAdvanceCountStatistics.total_invoices == 0" class="text-center">
            <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
            <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
          </div>
          <div v-show="getInvoiceAndAdvanceCountStatistics.total_invoices > 0" class="p-5">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-7 mb-5">
                <div class="row position-relative">
                  <canvas id="kt_chartjs_moyen_invoices" class="mh-400px"></canvas>
                  <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; height: 50%; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                    <div class="text-center">
                      <h1 class="display-2">{{getInvoiceAndAdvanceCountStatistics.total_invoices}}</h1>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4 d-flex justify-content-center align-items-center">
                <div class="p-5" style="border: 2px solid #CCCFD3; border-radius: 8px; width: 100%;">
                  <div class="d-flex mb-15">
                    <span class="bg-primary px-20 py-5 me-2" style="border-radius: 5px;"></span>
                    <span class="mt-2">{{ $t('invoices.total_invoice') }}: <span class="fw-bold">{{getInvoiceAndAdvanceCountStatistics.total_invoices}}</span></span>
                  </div>
                  <div class="d-flex mb-5">
                    <span class="px-20 py-5 me-2" style="border-radius: 5px; background-color: #0072CE66;"></span>
                    <span class="mt-2">{{ $t('invoices.advance_invoice_total') }}: <span class="fw-bold">{{getInvoiceAndAdvanceCountStatistics.total_advances}}</span></span>
                  </div>
                  <div class="row text-start fw-bold fs-3">
                    <div v-html="formattedInvoicePercent"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm mb-5 card-flush overflow-hidden">
        <div class="card-header">
          <div class="card-title">
            <h5 style="text-align: start">{{ $t('invoices.invoice_moyen_due_date') }}</h5>
          </div>
          <div class="card-toolbar">
            <ButtonDropdownFilter
                :btn-title="$t('pipelines.label.prospect')"
                :options="contacts"
                value-field="id"
                name-field="fullname"
                v-model="query.contact_id"
                :border="true"
            />
          </div>
        </div>
        <div class="card-body d-flex text-center justify-content-center flex-column px-0">
          <div v-show="getAveragePaymentDelay == 0" class="text-center">
            <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
            <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
          </div>
          <div class="p-5">
            <canvas id="kt_chartjs_payments" class="mh-400px"></canvas>
          </div>
        </div>
      </div>
    </template>
  </SubLayout>
</template>
<script setup>
import {onMounted, ref, nextTick, shallowRef, computed, watch} from "vue";
import {useStore} from "vuex";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import i18n from '@/plugins/i18n';
import {$formatLocalAmount} from "@/mixins/Helpers";
import DateRangePicker from "@/components/DateRangePicker.vue";
import {formattedLocalAmount} from "@/mixins/Helpers";
import { useLocales } from "@/composables/locales";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
import CrmInvoiceStatByStatus from "@/components/stats/widgets/CrmInvoiceStatByStatus.vue";

const {locale} = useLocales()
const store = useStore()

const title = ref( "navigation.statistics")
const breadcrumbs = ref([
  {
    name: 'invoices.invoice',
    path: '/admin'
  }
])

const query = ref({
  start_date: '',
  end_date: '',
  payment_type_id: '', 
  contact_id: ''
})

const averageInvoices = ref([])
const saleEstimates = ref([])
const topClients = ref([])
const averagePaidInvoiceAmount = ref(0)
const getAveragePaymentDelay = ref(0)
const getInvoiceAndAdvanceCountStatistics = ref([])

const chartPaymentRef = shallowRef(null)
const chartPipelineRef = shallowRef(null)
const chartTopClientRef = shallowRef(null)

const contacts = computed(() => store.getters['contacts/getContacts'])
const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])


watch(() => query.value.contact_id, (value) => {
  loadData()
})


watch(() => query.value.payment_type_id, (value) => {
  loadData()
})

function handleRangeDate (range) {
  query.value.start_date = range.start_date
  query.value.end_date = range.end_date
  if(query.value.start_date && query.value.end_date) loadData()
}

const formattedInvoicePercent = computed(() => {
    return i18n.global.t('invoices.invoice_validate_percent', { percent: getInvoiceAndAdvanceCountStatistics.value.percentage_with_advance+'%' });
});

async function loadWidgetStatData(params) {
    try {
      const res = await store.dispatch('invoices/getInvoiceStats', params)
      return res
    } finally {
    }
  }
  

function loadData(){
  Promise.all([
    store.dispatch('invoices/getInvoiceStats', {startDate: query.value.start_date, endDate: query.value.end_date, payment_type_id: query.value.payment_type_id, contact_id: query.value.contact_id}).then((res) => {
      topClients.value = res.data?.topCustomer
      averageInvoices.value = res.data?.invoiceStatusTurnover
      averagePaidInvoiceAmount.value = res.data?.averagePaidInvoiceAmount
      getAveragePaymentDelay.value = res.data?.getAveragePaymentDelay
      saleEstimates.value = res.data?.estimate_sales_by_period
      getInvoiceAndAdvanceCountStatistics.value = res.data?.getInvoiceAndAdvanceCountStatistics
    }),
    store.dispatch('company/generalInformation'),
    store.dispatch('contacts/loadContacts'),
  ]).then(() => {
    chartPayment()
    chartPipeline()
    nextTick(() => {
      chartTopClient()
    })
  })
}

onMounted(() => {
  let start = moment().subtract(29, 'days');
  let end = moment();
  query.value.start_date = start.format('DD-MM-YYYY')
  query.value.end_date = end.format('DD-MM-YYYY')

  if(query.value.start_date && query.value.end_date){
    nextTick(() => {
      loadData();
    });
  }
})

function filterStatus(value){
  let statistic = invoiceStatus.value?.find(status => status.value === value)
  return statistic
}

function chartPipeline(){
  let names = [];
  let counts = [];
  let colors = [];

  if(getInvoiceAndAdvanceCountStatistics.value.total_advances > 0){
    names.push(i18n.global.t('invoices.advance_invoice_total'))
    counts.push(getInvoiceAndAdvanceCountStatistics.value.total_advances)
    colors.push('#0072CE66')
  }
  if(getInvoiceAndAdvanceCountStatistics.value.total_invoices > 0){
    names.push(i18n.global.t('invoices.total_invoice'))
    counts.push(getInvoiceAndAdvanceCountStatistics.value.total_invoices)
    colors.push('#0072CE')
  }

  if(names.length === 0 || counts.length === 0 || colors.length === 0){
    getInvoiceAndAdvanceCountStatistics.value = [];
  }

  let ctx = document.getElementById('kt_chartjs_moyen_invoices');

  if (ctx) {
    let context = ctx.getContext('2d');
    let fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');

    let data = {
        labels: names,
        datasets: [{
          data: counts,
          backgroundColor: colors,
          hoverOffset: 10
      }]
    };

    let config = {
        type: 'doughnut',
        data: data,
        options: {
          plugins: {
              legend: {
                  display: true,
                  position: 'bottom'
              },
              tooltip: {
                  callbacks: {
                      label: function(context) {
                        let countLabel = i18n.global.t('invoices.count');
                          return `${countLabel}: ${$formatLocalAmount(context.parsed)}`;
                      }
                  }
              },
              centerText: {
                display: true,
                text: '15'
              }
          },
          responsive: true,
          elements: {
            arc: {
                borderWidth: 1 
            }
          },
          cutout: '80%'
        },
        defaults:{
            global: {
                defaultFont: fontFamily
            }
        }
    };

    if (!chartPipelineRef.value) {
      chartPipelineRef.value = new Chart(ctx, config);
    }else{
      chartPipelineRef.value.destroy()
      chartPipelineRef.value = new Chart(ctx, config);
    }
  } else {
    console.error('Canvas element not found');
    return;
  }
}

function chartTopClient() {
  const ctx = document.getElementById('kt_chartjs_top_clients').getContext('2d');
      
  const data = []
    topClients.value?.forEach(item => {
       data.push({
        name: item.name,
        amount: item.total_paid
       })
    })

  let config = {
    type: 'bar',
    data: {
      labels: data.map(item => item.name),
      datasets: [{
        label: i18n.global.t('invoices.top_clients'),
        data: data.map(item => item.amount),
        backgroundColor: data.map(item => '#0072CE'),
        borderColor: data.map(item => '#0056A1'),
        borderRadius: 10,
        borderWidth: 1
      }]
    },
    options: {
      responsive: true,
      plugins: {
        tooltip: {
          callbacks: {
            label: function(context) {
              return `${context.label}: ${$formatLocalAmount(context.raw)} ${defaultCurrency.value?.symbol}`;
            }
          }
        }
      },
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false
          }
        },
        y: {
          stacked: true,
          beginAtZero: true
        }
      }
    }
  };

  if (!chartTopClientRef.value) {
    chartTopClientRef.value = new Chart(ctx, config);
  }else{
    chartTopClientRef.value.destroy()
    chartTopClientRef.value = new Chart(ctx, config);
  }
}

function chartPayment() {
  const ctx = document.getElementById('kt_chartjs_payments').getContext('2d');
  let colors = ['rgba(45, 163, 51, 1)', 'rgba(243, 220, 31, 1)', 'rgba(240, 120, 23, 1)', 'rgba(229, 19, 53, 1)'];
  let number = getAveragePaymentDelay.value[locale.value]?.split(' ')[0]
  const gradient = ctx.createLinearGradient(0, 0, ctx.canvas.width, 0);
  gradient.addColorStop(0, 'rgba(45, 163, 51, 1)');
  gradient.addColorStop(0.33, 'rgba(243, 220, 31, 1)');
  gradient.addColorStop(0.66, 'rgba(240, 120, 23, 1)');
  gradient.addColorStop(1, 'rgba(229, 19, 53, 1)');

  let intervals = [3, 6, 9, 12];
  let colorIndex = 0;
  for (let i = 0; i < intervals.length; i++) {
    if (number <= intervals[i]) {
      colorIndex = i;
      break;
    }
  }

  let data = {
    labels: ['0-3', '3-6', '6-9', '9-12'],
    datasets: [{
      data: [25, 25, 25, 25],
      backgroundColor: gradient,
      hoverOffset: 10,
      borderColor: 'transparent'
    }]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      },
    },
    cutout: '70%',
    rotation: -90,
    circumference: 180
  };

  let config = {
    type: 'doughnut',
    data: data,
    options: options,
    plugins: [{
      afterDraw: function(chart) {
        let width = chart.width,
          height = chart.height,
          ctx = chart.ctx;

        ctx.restore();
        let fontSize = (height / 114).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";

        let text = `${getAveragePaymentDelay.value[locale.value]}`,
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 1.30;

        ctx.fillStyle = colors[colorIndex];
        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    }]
  };

  if (!chartPaymentRef.value) {
    chartPaymentRef.value = new Chart(ctx, config);
  } else {
    chartPaymentRef.value.destroy();
    chartPaymentRef.value = new Chart(ctx, config);
  }
}
</script>
